export const EXTERNAL_LINKS = {
  HOW_IT_WORKS: 'https://zesty-torrone-b2bea6.netlify.app/',
} as const
